import { useLoadedAndVisible } from 'src/common/hooks';
import { RoomsList } from 'src/features/module/components/rooms-list/rooms-list';
import { NextModules } from 'src/features/module/components/next-modules/next-modules';
import { WhatAreModules } from 'src/features/module/components/what-are-modules/what-are-modules';
import { StyledContainer, StyledMainContentOuter } from './main-content.styles';
import { MainContentProps } from './main-content.types';
export const MainContent: React.FC<MainContentProps> = ({
  rooms,
  prerequisites,
  nextSteps,
  isCtfModule = false,
  isMitreAssignmentModule = false
}) => {
  const isVisible = useLoadedAndVisible(rooms);
  return <StyledMainContentOuter data-sentry-element="StyledMainContentOuter" data-sentry-component="MainContent" data-sentry-source-file="main-content.tsx">
      <StyledContainer $isVisible={isVisible} data-sentry-element="StyledContainer" data-sentry-source-file="main-content.tsx">
        <RoomsList rooms={rooms} data-sentry-element="RoomsList" data-sentry-source-file="main-content.tsx" />
        {!isCtfModule && !isMitreAssignmentModule && <div>
            {prerequisites && prerequisites?.length > 0 && <NextModules title="Need to know" moduleAriaLabel="Need to know&#58;" modules={prerequisites} />}
            {nextSteps && nextSteps?.length > 0 && <NextModules title="Next steps" moduleAriaLabel="Next steps&#58;" modules={nextSteps} />}
            <WhatAreModules />
          </div>}
      </StyledContainer>
    </StyledMainContentOuter>;
};